import Cookies from 'cookie-universal'
import { FIRE_EMAIL_CAPTURED } from '@mc/constants'
import { FireEmailCaptureProps } from '../types'

export const setFireEmailCaptureCookie: (
  args: FireEmailCaptureProps,
) => void = ({ authType, captureMethod }) => {
  const cookies = Cookies()
  // Set cookie for future usage in the payment step email_capture_method
  cookies.set(FIRE_EMAIL_CAPTURED, {
    authType,
    ...(captureMethod && { captureMethod }),
  })
}
